import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Image from '../chrome/Image';

const baseButtonStyles = () => css`
  border: none;
  padding: 0;
  width: 100%;
  max-width: 350px;
`;
const StyledButton = styled('button')(baseButtonStyles);

const AdvertisingTile = ({ onSelect, ...rest }) => {
  return (
    <StyledButton
      onClick={() => {
        onSelect();
      }}
    >
      <Image {...rest} />
    </StyledButton>
  );
};

AdvertisingTile.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  naturalSize: PropTypes.bool,
  isSvg: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

AdvertisingTile.defaultProps = {
  src: 'https://via.placeholder.com/350x200',
  alt: 'For Placement Only',
  naturalSize: true,
  isSvg: false,
  onSelect: () => {
    console.log('should run the function passed in onSelect');
  },
};

export default AdvertisingTile;
